<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Payment Method to Book'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="'right-side-scroll-enabled'">
    
    <tidy-card>
      <!-- Stripe Card Form -->
      @if (!cardAdded()) {
        @if (!stripeReady()) {
          <div class="form-row">
            <ion-skeleton-text animated style="width: 100%; height: 22px; margin: 0;" />
          </div>
        }
        <div class="form-row" [class.stripe-loading]="!stripeReady()">
          <form>
            <div id="card-info" #cardInfo></div>
          </form>
        </div>

        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }
      }

      @if (cardAdded()) {
        <tidy-alert>
          <tidy-row class="no-padding">
            <tidy-image [src]="'assets/img/checkmark-circle-green.svg'" class="header-size" />
            <tidy-text [body]="cardBrand() + (' ending in ' | translate) + cardLast4()" />
          </tidy-row>
        </tidy-alert>
      }

      <tidy-row [align]="'center'">
        <tidy-text [body]="'<b>You will not be charged anything until you complete jobs.</b>'" />
      </tidy-row>
    </tidy-card>

    <!-- Enable Autopilot button -->
    <tidy-button
      [text]="isAddingCard() ? 'Saving...' : 'Add Payment Method'"
      [action]="goLive.bind(this)"
      class="primary extra-top-padding extra-bottom-padding" />
  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
